import { useCallback, useMemo } from "react"
import { useRecoilState } from "recoil"
import { DirtyFormState } from "state/DirtyFormState"

export const useDirtyForm = () => {

    const [dirtyForm, setDirtyForm] = useRecoilState(DirtyFormState)

    /**
     * Mark a form as dirty
     * @param id Form id to add in
     */
    const addDirty = useCallback((id: string) => {
        setDirtyForm((v) => {
            if (!v.some((item) => item === id)) {
                return [...v, id]
            }
            return v
        })
    }, [])

    const removeDirty = useCallback((id: string) => {
        setDirtyForm((v) => {
            const index = v.findIndex((item) => item === id)
            if (!index) {
                const newVal = [...v]
                newVal.splice(index, 1)
                return newVal
            }
            return v
        })
    }, [])

    const resetDirty = useCallback(() => {
        setDirtyForm((v) => ([]))
    }, [])

    const hasDirty = useMemo(() => {
        return dirtyForm.length > 0
    }, [dirtyForm])

    const isDirty = useCallback((id: string) => {
        return dirtyForm.some((item) => item === id)
    }, [dirtyForm])

    return {
        addDirty,
        removeDirty,
        resetDirty,
        dirtyForm,
        hasDirty,
        isDirty
    }
}
